// import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../Stylesheets/Footer.css";

import {
  faSquareWhatsapp,
  faSquareInstagram,
  faSquareFacebook,
} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  // const navItems = [
  //   {
  //     link: "https://play.google.com/store/apps/details?id=com.nbmedu.liveexam&hl=en_IN",
  //     img: "https://d242nlqul83u9g.cloudfront.net/WEB/common/googleplay.png",
  //   },
  //   {
  //     link: "https://apps.apple.com/in/app/vidhvaa-careermate/id6474591990",
  //     img: "https://d242nlqul83u9g.cloudfront.net/WEB/common/apple.png",
  //   },
  // ];

  return (
    <footer className="text-light pt-4" style={{ fontSize: "0.95rem" }}>
      <div className="container d-flex justify-content-center justify-content-md-between align-items-center flex-wrap firstrow">
        {/* <a style={{ width: "100%", maxWidth: "300px" }}></a> */}
        {/* Logo */}
        <a href="/" className="mb-3 mb-md-0">
          <img
            className="footer-logo"
            // src="https://d242nlqul83u9g.cloudfront.net/NB_Media/15.05.2025/web_size_2.png"
            src="https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img11545_IMG.png"
            alt="logo"
            style={{ maxWidth: "180px" }}
          />
        </a>
        {/* <a
          href="https://nbmediatech.com/home"
          target="_blank"
          rel="noreferrer"
          className="mb-3 mb-md-0"
        >
          <img
            className="footer-logo"
            src="https://d242nlqul83u9g.cloudfront.net/NB_Media/15.05.2025/web_size_2.png"
            alt="logo"
            style={{ maxWidth: "180px" }}
          />
        </a> */}
      </div>

      <div className="container d-flex justify-content-center justify-content-md-between align-items-center flex-wrap secondrow mt-2">
        <img
          src="https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/elcot57730_IMG.jpg"
          alt="elcotimg"
          style={{ width: "100%", maxWidth: "300px" }}
        />
        <ul className="d-flex flex-column mt-1">
          <li>
            <svg
              _ngcontent-kch-c8=""
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 16 16"
              className="bi bi-telephone-inbound-fill"
            >
              <path
                _ngcontent-kch-c8=""
                fillRule="evenodd"
                d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM15.854.146a.5.5 0 0 1 0 .708L11.707 5H14.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v2.793L15.146.146a.5.5 0 0 1 .708 0"
              ></path>
            </svg>{" "}
            +91 89259 59164
          </li>
          <li>
            <svg
              _ngcontent-kch-c8=""
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 16 16"
              className="bi bi-telephone-inbound-fill"
            >
              <path
                _ngcontent-kch-c8=""
                fillRule="evenodd"
                d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM15.854.146a.5.5 0 0 1 0 .708L11.707 5H14.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v2.793L15.146.146a.5.5 0 0 1 .708 0"
              ></path>
            </svg>{" "}
            +91 81488 80172
          </li>
          <li>
            <svg
              _ngcontent-kch-c8=""
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 16 16"
              className="bi bi-telephone-inbound-fill"
            >
              <path
                _ngcontent-kch-c8=""
                fillRule="evenodd"
                d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM15.854.146a.5.5 0 0 1 0 .708L11.707 5H14.5a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 1 0v2.793L15.146.146a.5.5 0 0 1 .708 0"
              ></path>
            </svg>{" "}
            +91 89259 59166
          </li>
        </ul>

        <ul className="d-flex flex-column">
          <li>
            <svg
              _ngcontent-kch-c8=""
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 16 16"
              className="bi bi-envelope-at-fill"
            >
              <path
                _ngcontent-kch-c8=""
                d="M2 2A2 2 0 0 0 .05 3.555L8 8.414l7.95-4.859A2 2 0 0 0 14 2zm-2 9.8V4.698l5.803 3.546zm6.761-2.97-6.57 4.026A2 2 0 0 0 2 14h6.256A4.5 4.5 0 0 1 8 12.5a4.49 4.49 0 0 1 1.606-3.446l-.367-.225L8 9.586zM16 9.671V4.697l-5.803 3.546.338.208A4.5 4.5 0 0 1 12.5 8c1.414 0 2.675.652 3.5 1.671"
              ></path>
              <path
                _ngcontent-kch-c8=""
                d="M15.834 12.244c0 1.168-.577 2.025-1.587 2.025-.503 0-1.002-.228-1.12-.648h-.043c-.118.416-.543.643-1.015.643-.77 0-1.259-.542-1.259-1.434v-.529c0-.844.481-1.4 1.26-1.4.585 0 .87.333.953.63h.03v-.568h.905v2.19c0 .272.18.42.411.42.315 0 .639-.415.639-1.39v-.118c0-1.277-.95-2.326-2.484-2.326h-.04c-1.582 0-2.64 1.067-2.64 2.724v.157c0 1.867 1.237 2.654 2.57 2.654h.045c.507 0 .935-.07 1.18-.18v.731c-.219.1-.643.175-1.237.175h-.044C10.438 16 9 14.82 9 12.646v-.214C9 10.36 10.421 9 12.485 9h.035c2.12 0 3.314 1.43 3.314 3.034zm-4.04.21v.227c0 .586.227.8.581.8.31 0 .564-.17.564-.743v-.367c0-.516-.275-.708-.572-.708-.346 0-.573.245-.573.791"
              ></path>
            </svg>{" "}
            nb.techbridge@gmail.com
          </li>

          <li>
            {" "}
            <svg
              _ngcontent-kch-c8=""
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              viewBox="0 0 16 16"
              className="bi bi-geo-alt-fill"
            >
              <path
                _ngcontent-kch-c8=""
                d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10m0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6"
              ></path>
            </svg>{" "}
            1st Floor, Elcot SEZ-IT Park
          </li>
          <li className="ps-4">Ilandhaikulam, Madurai</li>
          <li className="ps-4">Tamil Nadu-625020</li>
        </ul>
      </div>

      <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center border-top border-secondary ">
        {/* Copyright */}
        <p className="mb-2 mb-md-0 " style={{ fontSize: "0.95rem" }}>
          © {new Date().getFullYear()} NBMedia. All Rights Reserved
        </p>

        {/* <ul className="d-flex list-unstyled mb-3 mb-md-0">
          {navItems.map((item, index) => (
            <li key={index} className="">
              <a href={item.link} target="_blank" rel="noreferrer">
                <img
                  src={item.img}
                  alt="app link"
                  style={{ maxWidth: "140px" }}
                />
              </a>
            </li>
          ))}
        </ul> */}

        {/* Social Links */}
        <div className="d-flex social-icons ">
          <a
            href="https://www.facebook.com/profile.php?id=61587810385286"
            target="_blank"
            rel="noreferrer"
            className="facebook"
          >
            <FontAwesomeIcon icon={faSquareFacebook} />
          </a>
          <a
            href="https://www.instagram.com/nb_media_techbridge"
            target="_blank"
            rel="noreferrer"
            className="instagram"
          >
            <FontAwesomeIcon icon={faSquareInstagram} />
          </a>
          {/* <a
            href="https://api.whatsapp.com/send?phone=8925959164"
            target="_blank"
            rel="noreferrer"
            className="whatsapp"
          >
            <FontAwesomeIcon icon={faSquareWhatsapp} />
          </a> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
